module.exports = __webpack_public_path__ + "img/mobile_2.f55680dd.jpg";